import { apyToApr } from '../../../utils/parsing'
import { averageDataLastN } from '../../helpers'
import { YieldFetcher } from '../../types'

const JITOSOL_URL = 'https://www.jito.network/api/getJitoPoolStats/'
const jitoSol = 'Jito Staked SOL::JitoSOL'

export const jitoSolFetcher: YieldFetcher = {
  label: 'JITOSOL',
  fetch: async () => {
    const res = await fetch(JITOSOL_URL, {
      method: 'GET',
      headers: { Accept: 'application/json', 'User-Agent': '1delta/yields' },
    }).then((r) => r.json())
    const val = averageDataLastN(res?.getStakePoolStats?.apy, 7)
    return { [jitoSol]: apyToApr(val) * 100 }
  },
}
